<template>
  <div id="wrap">
    <Header/>
    <Scroll/>
    <div class="mall_pageTopWrap">
      <div class="pageArticleDatail_Inner">
        <p class="pageArticleDatail_tit">{{statusData.topBannerData.top_banner_title}}</p>
        <p class="pageArticleDatail_susTit">{{statusData.topBannerData.top_banner_sub_title}}</p>
        <div class="hp_newsEditor">
          <div v-if="isPC">
            <div v-html="statusData.topBannerData.top_banner_editor"/>
          </div>
          <div v-else>
            <div v-html="statusData.topBannerData.top_banner_editor_mobile"/>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref, computed } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_top_banner_one
} from '../../ETC/Axios.vue'

export default {
  name: 'TopBanner',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    const statusData = ref({
      topBannerData: []
    })

    const isPC = computed(() => {
      return window.innerWidth > 768
    })

    return {
      statusData,
      isPC
    }
  },
  mounted () {
    get_top_banner_one(this.$route.query.top_banner_ID).then(result_data => {
      this.statusData.topBannerData = result_data[0]
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Banner/TopBanner.vue